import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Switch } from 'antd';
import ExpirationTypeSelect from './expiration-type-select';

export default function FormOtherDocumentTemplate({
  handleSubmit,
  initialValues,
  showExpiration,
  form,
}) {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={initialValues}
    >
      <Form.Item label="Active" name="active" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter a item name' }]}
      >
        <Input size="large" />
      </Form.Item>

      {showExpiration && <ExpirationTypeSelect form={form} />}

      <Form.Item label="Description" name="description">
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
}

FormOtherDocumentTemplate.propTypes = {
  initialValues: PropTypes.shape({
    active: PropTypes.bool,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  showExpiration: PropTypes.bool,
};

FormOtherDocumentTemplate.defaultProps = {
  showExpiration: false,
};
